import { useMutation } from "@tanstack/react-query";
import { apiClient } from '../api-manager-instance';
import { ENDPOINTS } from '../endpoints';

export interface IPreviewBatchMergePayload {
    sourceBatchId: string;
    targetBatchId: string;
}

export interface IPreviewBatchMergeResponse {
    success: boolean;
    eligible: boolean;
    reason?: string;
    preview?: {
        sourceOrdersCount: number;
        targetOrdersCount: number;
        projectedTotalOrders: number;
        projectedPickupStops: number;
        projectedDropoffStops: number;
        projectedTotalDistance: number;
        projectedType: 'single_merchant' | 'cross_merchant' | string;
    };
}

export const usePreviewBatchMerge = () => {
    return useMutation({
        mutationFn: async (payload: IPreviewBatchMergePayload): Promise<IPreviewBatchMergeResponse> => {
            const res = await apiClient.post(ENDPOINTS.BATCHES.MERGE_PREVIEW, payload);
            return res.data;
        },
    });
};
